export default __webpack_public_path__ + "static/media/KUshare.d4bd009d.svg";